import type { InputMode } from '@brighterly/lib-core-types/ui/inputs/types'

import { getMode } from '@shared/lib/mode'

import { useTutorApplicationStore } from '../store'

interface TeacherRecommendedReturn {
  mode: ComputedRef<InputMode>
  label: string
  setRecommended: (value: boolean) => void
}

export const useTeacherRecommended = (): TeacherRecommendedReturn => {
  const tutorApplicationStore = useTutorApplicationStore()

  const label = 'Current Brighterly teacher recommended to me to apply for this job'

  const mode = computed(() => getMode(tutorApplicationStore.showErrors && tutorApplicationStore.form.recommended === null))

  const setRecommended = (value: boolean): void => {
    tutorApplicationStore.setField('recommended', value)
  }

  return {
    mode,
    label,
    setRecommended,
  }
}
